module.exports = __webpack_public_path__ + "img/thumb_10.7acaa48e.jpg";